import {
  Box,
  VStack,
  Text,
  /*Stack,*/ HStack,
  CircularProgress,
} from "@chakra-ui/react";
import Button from "../Button/Button";

import { useHistory } from "react-router-dom";

import useCoinInfo from "hooks/useCoinInfo";

import toPrecision from "util/toPrecision";

import { AnimatePresence, motion } from "framer-motion";

// const MotionVStack = motion(VStack);

const WalletActions = ({ coin, data, isLoading, rate, isRating }) => {
  const history = useHistory();

  const { icon, label } = useCoinInfo(coin);

  return (
    <Box
      bg="white"
      border="1px solid #EFF0F6"
      p="30px"
      borderRadius="16px"
      minH="320px"
    >
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          transition={{ delay: 0.2, duration: 0.3 }}
        >
          {isLoading && !data && (
            <VStack py="32px">
              <CircularProgress
                ml="20px !important"
                isIndeterminate
                color="var(--primary)"
                size="22px"
              />
            </VStack>
          )}
          {!isLoading && data && (
            <VStack
            // initial={{ opacity: 0, scale: 0.94 }}
            // animate={{ opacity: 1, scale: 1 }}
            // exit={{ opacity: 0, scale: 0.94 }}
            >
              <VStack>
                <VStack>
                  <Box boxSize="48px" as={icon} />
                  <Text color="#4E4B66" fontSize="md">
                    {label}
                  </Text>
                </VStack>

                <VStack>
                  <Text fontSize="20px" color="var(--primary)" fontWeight="600">
                    {toPrecision(data?.balance?.$numberDecimal, coin)}
                  </Text>
                  {!isRating && rate && (
                    <Text color="#4E4B66" fontSize="sm" mt="2px !important">
                      {toPrecision(rate, "usd")}
                      {/* USD (11%) */}
                    </Text>
                  )}
                  {isRating && (
                    <CircularProgress
                      ml="20px !important"
                      isIndeterminate
                      color="var(--primary)"
                      size="22px"
                    />
                  )}
                </VStack>
              </VStack>

              <HStack mt="32px !important">
                <Button
                  minH="64px"
                  onClick={() =>
                    history.push(`/dashboard/wallet/${coin}/deposit`)
                  }
                >
                  Deposit
                </Button>
                <Button
                  color="var(--primary)"
                  minH="64px"
                  border="1px solid var(--primary)"
                  bg="transparent"
                  onClick={() =>
                    history.push(`/dashboard/wallet/${coin}/withdraw`)
                  }
                >
                  Withdraw
                </Button>
              </HStack>
            </VStack>
          )}
        </motion.div>
      </AnimatePresence>
    </Box>
  );
};

export default WalletActions;
